import React from 'react';

export function CopyRight() {
  const year = React.useRef<string>(new Date().getFullYear().toString());

  return (
    <p className="absolute text-sm text-black bottom-5 md:bottom-20 left-5 md:left-20 ">
      © {year.current} Vodacom. All Rights Reserved.Terms & Conditions
    </p>
  );
}
